/**************
 Cart
 ***************/

let samplePackID = 9422140113186;

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    const variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    const variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    const variantIDToImage = cartData.variantIDToImage;
    const variantIDToTitle = cartData.variantIDToTitle;
    const variantIDToIsCase = cartData.variantIDToIsCase;


    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // check if the sample pack is in the cart
    let samplePacksInCart = cart.items.find(item => item.product_id === samplePackID);

    // if there is more than 1 sample pack in the cart, remove all but one
    if (samplePacksInCart && samplePacksInCart.quantity > 1) {

        // update product
        await changeCart({
            quantity: 1,
            id: samplePacksInCart.key
        });

        // show error message
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'You can only have one Sample Pack in your cart at a time.',
            target: document.querySelector('#miniCart')
        });

        // open cart
        await openCart();

        return;


    }


    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('.headerIconsItem.openCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector(".miniCartHeaderWrap")?.classList.remove("active");
        document.querySelector(".miniCartUpsell")?.classList.add("active");
        document.querySelectorAll(".miniCartUpsellItem")?.forEach(element => {
            element.classList.add("active");
        });
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector(".miniCartUpsell")?.classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");


    // reset sections
    document.querySelector('#miniCartHeaderTxt').classList.remove('active');


    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        document.querySelector(".miniCartHeaderWrap")?.classList.add("active");

        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }


    // Free shipping for cases
    if (cartSettings.free_shipping_method === "cases") {
        // hide bar
        document.querySelector('.miniCartHeaderWrap').classList.remove('active');

        // check how many cases are in cart
        let casesInCart = 0;
        cart.items.forEach(item => {
            if (parseInt(variantIDToIsCase[item.variant_id])) {
                casesInCart += item.quantity;
            }
        });

        // update text
        document.querySelector("#miniCartHeaderTxt").textContent = document.querySelector("#miniCartHeaderTxt").dataset.before;
        if (casesInCart >= 2) {
            document.querySelector("#miniCartHeaderTxt").textContent = document.querySelector("#miniCartHeaderTxt").dataset.success;
        }

        document.querySelector('#miniCartHeaderTxt').classList.add('active');

    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        document.querySelector(".miniCartHeaderWrap")?.classList.add("active");

        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (variantIDToCompareAtPrice[item.variant_id]) {
                comparePrices.push(variantIDToCompareAtPrice[item.variant_id] * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                }
            }

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // get selling plan id and name
            let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
            let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

            // check if selling plan exists
            if (!sellingPlanID) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}"
                >
               ${sellingPlanName}
                </button>
            `;
        }

        // hides quantity selector if the item is a sample pack
        function hiddenCSS() {
            let CSS = ``;
            if (item.product_id === samplePackID) {
                CSS = `hidden`;
            }

            return CSS
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${variantIDToImage[item.variant_id]}" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${variantIDToTitle[item.variant_id]}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                         <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                       
                    </div>
                    <div class="miniCartBodyItemFlex bottom">
                        <div class="miniCartBodyItemQuantity ${hiddenCSS()}">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg width="8" height="3" viewBox="0 0 8 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.246094 2.06413V0.867127H7.21809V2.06413H0.246094Z" fill="#1D1E20"/>
                                </svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.66909 7.8723V4.5543H0.729094V3.3783H3.66909V0.102301H4.82409V3.3783H7.78509V4.5543H4.82409V7.8723H3.66909Z" fill="#1D1E20"/>
                                </svg>
                            </button>
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_372_10180)">
                                    <path d="M18.518 4.8674H1.48297C1.06797 4.8674 0.730469 4.5299 0.730469 4.1149C0.730469 3.6999 1.06797 3.3624 1.48297 3.3624H18.518C18.933 3.3624 19.2705 3.6999 19.2705 4.1149C19.2705 4.5299 18.933 4.8674 18.518 4.8674Z" fill="#5E5E5E"/>
                                    <path d="M10.3871 19.8974H9.61208C6.84207 19.8974 5.31708 19.8974 4.23207 18.8849C3.14957 17.8724 3.04707 16.3499 2.86207 13.5849L2.40207 6.6724C2.37457 6.2574 2.68707 5.8999 3.10207 5.8724C3.51707 5.8449 3.87458 6.1574 3.90208 6.5724L4.36207 13.4849C4.52707 15.9449 4.60957 17.1799 5.25957 17.7874C5.90957 18.3949 7.14708 18.3949 9.61208 18.3949H10.3871C12.8521 18.3949 14.0896 18.3949 14.7396 17.7874C15.3896 17.1799 15.4721 15.9449 15.6371 13.4849L16.0971 6.5724C16.1246 6.1574 16.4846 5.8449 16.8971 5.8724C17.3121 5.8999 17.6246 6.2574 17.5971 6.6724L17.1371 13.5849C16.9521 16.3499 16.8521 17.8724 15.7671 18.8849C14.6846 19.8974 13.1571 19.8974 10.3871 19.8974Z" fill="#5E5E5E"/>
                                    <path d="M7.99465 14.8874C7.61215 14.8874 7.28715 14.5974 7.24715 14.2099L6.74715 9.1999C6.70465 8.7874 7.00715 8.4174 7.41965 8.3774C7.83215 8.3349 8.20215 8.6374 8.24215 9.0499L8.74215 14.0599C8.78465 14.4724 8.48215 14.8424 8.06965 14.8824C8.04465 14.8849 8.01965 14.8874 7.99465 14.8874Z" fill="#5E5E5E"/>
                                    <path d="M12.0054 14.8874C11.9804 14.8874 11.9554 14.8874 11.9304 14.8824C11.5179 14.8399 11.2154 14.4724 11.2579 14.0599L11.7579 9.0499C11.8004 8.6374 12.1679 8.3349 12.5804 8.3774C12.9929 8.4199 13.2954 8.7874 13.2529 9.1999L12.7529 14.2099C12.7129 14.5974 12.3879 14.8874 12.0054 14.8874Z" fill="#5E5E5E"/>
                                    <path d="M15.5122 4.86739C15.4472 4.86739 15.4147 4.86739 15.3847 4.86739C14.8272 4.85239 14.2947 4.67489 13.8422 4.34739C13.3897 4.02239 13.0522 3.57239 12.8622 3.04989C12.8522 3.02239 12.8422 2.98989 12.8197 2.92739L12.7222 2.63489C12.6572 2.44239 12.6172 2.31739 12.5897 2.26489C12.4797 2.05489 12.2747 1.90739 12.0422 1.86989C11.9822 1.85989 11.8497 1.85989 11.6497 1.85989H8.35469C8.15219 1.85989 8.01969 1.85989 7.96219 1.86989C7.72719 1.90739 7.52469 2.05489 7.41469 2.26489C7.38719 2.31739 7.34469 2.44489 7.28219 2.63489L7.18469 2.92739C7.16469 2.98989 7.15219 3.01989 7.14219 3.04989C6.95219 3.57239 6.61469 4.02239 6.16219 4.34739C5.70969 4.67239 5.17719 4.85239 4.61969 4.86739C4.58969 4.86739 4.55719 4.86739 4.49219 4.86739V3.36489C4.53719 3.36489 4.56219 3.36489 4.58219 3.36489C5.10219 3.35239 5.55219 3.02739 5.72719 2.53989C5.73469 2.51989 5.74219 2.49739 5.75719 2.45489L5.85469 2.16239C5.94719 1.88489 5.99719 1.73239 6.07969 1.57239C6.40719 0.942394 7.02219 0.499894 7.72469 0.387394C7.90219 0.359894 8.06219 0.359894 8.35469 0.359894H11.6497C11.9422 0.359894 12.1022 0.359894 12.2797 0.387394C12.9822 0.499894 13.5947 0.942394 13.9247 1.57239C14.0072 1.72989 14.0572 1.88239 14.1497 2.15989L14.2472 2.45489C14.2622 2.49989 14.2697 2.51989 14.2772 2.53989C14.4547 3.02739 14.9047 3.35239 15.4222 3.36489C15.4422 3.36489 15.4672 3.36489 15.5122 3.36489V4.86739Z" fill="#5E5E5E"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_372_10180">
                                        <rect width="20" height="20" fill="white" transform="translate(0 0.127396)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart(true);
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector(".miniCartUpsell")?.classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterPrice").textContent`Total: ${price(cart.i = tems_subtotal_price + cartSettings.protection_upsell.variants[0].price)}`;
    } else {
        document.querySelector("#miniCartFooterPrice").textContent = `Total: ${price(cart.items_subtotal_price)}`;
    }
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}